module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_icon02-f96862db3cf0c17c36dee9a1170a7caa.png";